
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const LocationTarget = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="LocationTarget" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M16 7.5h-2.025A6 6 0 008.5 2.025V0h-1v2.025A6 6 0 002.025 7.5H0v1h2.025A6 6 0 007.5 13.975V16h1v-2.025A6 6 0 0013.975 8.5H16zm-3.051 0H8.5V3.051A4.973 4.973 0 0112.949 7.5zM7.5 3.051V7.5H3.051A4.973 4.973 0 017.5 3.051zM3.051 8.5H7.5v4.449A4.973 4.973 0 013.051 8.5zM8.5 12.949V8.5h4.449A4.973 4.973 0 018.5 12.949z" />
</svg>
    </HvIconBase>
)};

LocationTarget.propTypes = HvIconBase.propTypes;

export default LocationTarget;